import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
import { nanoid } from 'nanoid'
import "./styles.scss";

interface IProps {
  activePage: number;
  handlePagination: (activePage: number) => void;
  totalItems: number;
  itemsPerPage: number;
}

const maxButtons = 5;

export const Paginations = (props: IProps) => {
  const handleClick = (activePage: number) => {
    props.handlePagination(activePage);
  };

  const totalPage = Math.ceil(props.totalItems / props.itemsPerPage);

  const getValuesToRender = (): number[] => {
    const values = [...Array(totalPage)];
    if (totalPage <= maxButtons) {
      return values.map((_, index) => index + 1);
    }

    return values.reduce((acc, _, i) => {
      const index = i + 1;
      if (index === 1) {
        if (props.activePage > 3) acc.push(index, -1);
        else acc.push(index);
      } else if (index === totalPage) {
        if (props.activePage <= totalPage - 3) acc.push(-1, index);
        else acc.push(index);
      } else if (
        props.activePage === index ||
        props.activePage + 1 === index ||
        props.activePage - 1 === index
      ) acc.push(index);
      return acc;
    }, []);
  };

  const itemCount = () => {
    return `Mostrando
    ${
      props.activePage === totalPage
        ? props.itemsPerPage * props.activePage -
          props.itemsPerPage +
          1 +
          " - " +
          props.totalItems
        : props.itemsPerPage * props.activePage -
          props.itemsPerPage +
          1 +
          " - " +
          props.itemsPerPage * props.activePage
    }
    de ${props.totalItems} elementos.`;
  };

  return (
    <>
      <div className="container-card-list text-center">{itemCount()}</div>
      <Pagination className="d-flex justify-content-center">
        <PaginationItem key={nanoid(4)} disabled={props.activePage === 1 ? true : false}>
          <PaginationLink first onClick={() => handleClick(1)} />
        </PaginationItem>
        <PaginationItem key={nanoid(4)} disabled={props.activePage === 1 ? true : false}>
          <PaginationLink
            previous
            onClick={() => handleClick(props.activePage - 1)}
          />
        </PaginationItem>

        {[...getValuesToRender()].map((index) =>
          index === -1 ? (
            <PaginationItem key={nanoid(4)}>
              <PaginationLink disabled>...</PaginationLink>
            </PaginationItem>
          ) : (
            <PaginationItem
              key={nanoid(4)}
              className={props.activePage === index ? "active" : ""}
            >
              <PaginationLink onClick={() => handleClick(index)}>
                {index}
              </PaginationLink>
            </PaginationItem>
          )
        )}

        <PaginationItem
          key={nanoid(4)}
          disabled={props.activePage === totalPage ? true : false}
        >
          <PaginationLink
            next
            onClick={() => handleClick(props.activePage + 1)}
          />
        </PaginationItem>
        <PaginationItem
          key={nanoid(4)}
          disabled={props.activePage === totalPage ? true : false}
        >
          <PaginationLink last onClick={() => handleClick(totalPage)} />
        </PaginationItem>
      </Pagination>
    </>
  );
};
